const generator = {
  edit: "Editar",
  favorite: "Agregar a favoritos",
  placeholder: "Escribe una descripción detallada de tu producto o servicio",
};

export default generator;
